import React, { FC, useMemo } from 'react';
import { useRouter } from 'next/router';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import ProductsLoader from './ProductsLoader';
import { TPLPModule } from './PLPModule.definitions';
import { generateAlgoliaConfigProps } from './Algoliga.utils';
import PLPSchema from './components/PLPSchema';
import { Configure } from 'react-instantsearch';
import { PLPHero } from './components/PLPHero/PLPHero';
import { GTM_LIST_ID } from '~/shared/hooks/useEvents/useGTMEvents/models';
import { AlgoliaProductList } from '~/services/instantsearch/components';

const PLPModule: FC<TPLPModule> = ({
    heroHeader,
    heroTheme,
    categories,
    image,
    heroImageAltText,
    backgroundColor,
    hitsPerPage,
    filters,
    parentDataConfiguration,
    parentDataType,
    dataType,
    children,
    serverState,
    belowText,
    heroTrumpet,
    heroWatermark,
    heroColorTheme,
    enableAIProductGuideBanner,
}) => {
    const { asPath, query } = useRouter();

    const algoliaConfiguration = useMemo(
        () =>
            generateAlgoliaConfigProps({
                filter: filters,
                filterType: dataType,
                productIds: query?.productids ?? query?.productIds,
                campaign: query?.campaign,
                parentFilter: parentDataConfiguration,
                parentFilterType: parentDataType,
            }),
        [asPath],
    );

    return (
        <AlgoliaProductList>
            <Configure clickAnalytics />

            <PLPSchema />

            {!!heroHeader && (
                <PLPHero
                    belowText={belowText}
                    dataType={dataType}
                    image={image}
                    backgroundColor={backgroundColor}
                    heroImageAltText={heroImageAltText}
                    heroTheme={heroTheme}
                    heroColorTheme={heroColorTheme}
                    heroHeader={heroHeader}
                    heroWatermark={heroWatermark}
                    heroTrumpet={heroTrumpet}
                    categories={categories}
                    enableAIProductGuideBanner={enableAIProductGuideBanner}
                />
            )}

            <ModuleContainer hasGutter={false} spacingTop="none" fullWidth>
                {children}

                <ProductsLoader
                    withSchema
                    listId={GTM_LIST_ID.PRODUCT_LIST}
                    hitsPerPage={hitsPerPage}
                    configuration={algoliaConfiguration}
                    serverUrl={serverState?.serverUrl}
                />
            </ModuleContainer>
        </AlgoliaProductList>
    );
};

export default PLPModule;
